import {
    Alert,
    Box,
    Button,
    Modal
} from "@mui/material";
import React                  from "react";
import {
    AddAdres,
    AddAerosol,
    AddBassin,
    AddComplianceSchedule,
    AddContact,
    AddControle,
    AddInstallatie,
    AddPool,
    AuthToken,
    baseUrl,
    Delete,
    UpdateAdres,
    UpdateAerosol,
    UpdateBassin,
    UpdateComplianceSchedule,
    UpdateContact,
    UpdateInstallatie,
    UpdatePool
} from "../constants";
import {useZINContext}        from "../context/ZinContextProvider";
import AdresForm              from "../forms/AdresForm";
import AerosolForm            from "../forms/AerosolForm";
import BassinForm             from "../forms/BassinForm";
import ComplianceScheduleForm from "../forms/ComplianceScheduleForm";
import ContactForm            from "../forms/ContactForm";
import ControleForm from "../forms/ControleForm";
import DeleteForm from "../forms/DeleteForm";
import InstallatieForm        from "../forms/InstallatieForm";
import PoolForm               from "../forms/PoolForm";
import type {DialogProps}             from "@mui/material";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    maxHeight: "80vh",
    overflowY: "auto",
    overflowX: "auto",
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const UpsertObjectModal = () =>
{
    const {
        setModalVisible, modalVisible,
        modalAction,
        alertText, setAlertText,
        alertVisible, setAlertVisible
    } = useZINContext()

    const handleClose: DialogProps["onClose"] = (event, reason) =>
    {
        if (reason && reason === "backdropClick")
        {
            return;
        }

        setModalVisible(false);
        setAlertVisible(false)
    }


    function CurrentForm()
    {
        switch (modalAction)
        {
            case AddPool:
            case UpdatePool:
                return <PoolForm/>
            case AddAdres:
            case UpdateAdres:
                return <AdresForm/>
            case AddBassin:
            case UpdateBassin:
                return <BassinForm/>
            case AddContact:
            case UpdateContact:
                return <ContactForm/>
            case AddControle:
                return <ControleForm/>
            case AddInstallatie:
            case UpdateInstallatie:
                return <InstallatieForm/>
            case AddAerosol:
            case UpdateAerosol:
                return <AerosolForm/>
            case AddComplianceSchedule:
            case UpdateComplianceSchedule:
                return <ComplianceScheduleForm/>
            case Delete:
                return <DeleteForm/>

            default:
                return "Form is missing from Modal"

        }
    }

    return (<>
            <Modal
                open={modalVisible}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Button className={"od-button"} style={{float: "right"  }} onClick={e=> handleClose(e,"escapeKeyDown")}>Close</Button>

                    <Alert style={{
                        display: alertVisible
                                 ? "flex"
                                 : "none"
                    }} severity="error" color={"warning"}>{alertText}</Alert>

                    <html ig-base-url={baseUrl + "/ig"} ig-api-token={AuthToken}>
                    {CurrentForm()}

                    </html>
                </Box>
            </Modal>
        </>
    )
}
export default UpsertObjectModal